<script setup lang="ts">
import CloseButton from './CloseButton.vue'

const {
  headingTitle = 'Vyberte datum',
} = defineProps<{
  headingTitle?: string
}>()
</script>

<template>
  <div class="flex justify-between pt-5 pb-2.5 px-4 font-semibold items-center sm:hidden">
    {{ headingTitle }}
    <CloseButton />
  </div>
</template>
